<template>
  <div>
    <div
      :style="main"
      class="component-wrapper secondary suggested-pois white d-flex flex-column align-center pa-4"
    >
      <div
        v-for="(poi, i) in visitedPois"
        :key="i"
        class="d-flex flex-column mb-4"
        style="width: 100%"
      >
        <div
          @click="
            $router.push(`/islands/area/${poi.area_id}/pois/${poi.id}/map`)
          "
          class="d-flex justify-center align-center route font-weight-thin body-1 mb-2"
        >
          <v-card width="85vw" style="border-radius: 15px">
            <v-img
              width="100%"
              height="150px"
              v-if="poi.images.length != 0"
              :src="
                'https://api.e-naxios.com/images/' +
                poi.images[0].image[0].file_name
              "
            ></v-img>
            <div
              v-else
              style="width: 100%; height: 150px"
              class="d-flex align-center justify-center"
            >
              <v-icon size="100" color="secondary">
                mdi-image-off-outline
              </v-icon>
            </div>
            <div
              class="secondary--text body-2 font-weigth-regular category ml-6 pt-2"
              style="font-size: 12px"
            >
              {{
                poiCategory(poi.category_id) != null
                  ? poiCategory(poi.category_id).name
                  : ""
              }}
            </div>
            <div class="secondary--text body-1 font-weight-bold ml-6 pb-2">
              <span v-for="(item, i) in poi.translations" :key="i">
                <span v-if="item.locale == mobileLang.code">
                  {{ item.name }}
                </span>
              </span>
            </div>
          </v-card>
        </div>
      </div>

      <div v-if="visitedPois && visitedPois.length == 0" class="white--text">
        {{ $t("error_messages.no_pois") }}
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
  async created() {},

  data() {
    return {};
  },

  computed: {
    ...mapState({
      categories: (state) => state.pois.categories,
      mobileLang: (state) => state.base.mobileLang,

      visitedPois: (state) => state.pois.visitedPois,
      insets: (state) => state.base.insets,
    }),
    main() {
      return {
        margin: `${this.insets?.top}px 0px 0px 0px`,
      };
    },
  },

  methods: {
    poiCategory(category_id) {
      return this.categories.find((el) => el.id == category_id);
    },
  },
};
</script>

<style scoped lang="scss">
.suggested-pois {
  top: 0px;
  height: 100%;
  width: 100vw;
  position: absolute;
  // flex: 1 1 1px; /* new */
  overflow-y: auto !important;
}

.user-routes {
  top: 50vh; //suggested-routes height
  width: 100vw;
  height: calc(100% - 50vh);
  position: absolute;
  overflow-y: auto !important;
}

.route {
  width: 100%;
}

.category::before {
  content: "";
  position: absolute;
  left: 0;
  margin-top: 8px;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;

  width: 12px;
  height: 5px;
  background: var(--v-accent-base);
}

.check-icon {
  width: 19px;
  height: 14px;
}
</style>
